import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SectionGuidanceToggle from '../SectionGuidanceToggle/SectionGuidanceToggle';
import FlowNav from '../FlowNav/FlowNav';
import PlanSectionTrail from '../PlanSectionTrail/PlanSectionTrail';
import { getPartnerAccent } from '../../themes/partnerTheme';
import './ProcessBar.scss';

class ProcessBar extends Component {
  static propTypes = {
    color: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    stepSeq: PropTypes.number,
    totalSteps: PropTypes.number,
    prevText: PropTypes.string,
    nextText: PropTypes.string,
    prev: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    next: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    disableNext: PropTypes.bool,
    guidanceToggle: PropTypes.bool
  };

  static defaultProps = {
    color: getPartnerAccent('primary'),
    title: null,
    icon: null,
    subtitle: null,
    stepSeq: null,
    totalSteps: null,
    prevText: 'Previous',
    nextText: 'Next Step',
    prev: null,
    next: null,
    disableNext: false,
    guidanceToggle: true
  };

  render() {
    const {
      color,
      title,
      icon,
      subtitle,
      stepSeq,
      totalSteps,
      prev,
      next,
      prevText,
      nextText,
      disableNext,
      guidanceToggle
    } = this.props;
    const hasFlow = Boolean(prev || next);

    const metaRow =
    title || icon ? (
        <div className="process-bar__meta">
          <div className="process-bar-meta-content">
            {title && <><div className="process-bar-title">{title}</div> {guidanceToggle && <SectionGuidanceToggle className="process-bar-guidance-toggle" />}</> }
          </div>
          <div className="process-bar-meta-actions">
            {totalSteps ? (
              <div className="process-bar-subtitle">{`Step ${stepSeq} out of ${totalSteps}`}</div>
            ) : null}
            {subtitle ? <div className="process-bar-subtitle">{subtitle}</div> : null}
          </div>
        </div>
      ) : null;

    const head = (
      <div className="process-bar__head">
        {!hasFlow && (title || icon) ? (
          <div className="process-bar-leading">
            <div className="process-bar-title">
              {title}
              {icon}
            </div>
            {guidanceToggle ? <SectionGuidanceToggle className="process-bar-guidance-toggle" /> : null}
          </div>
        ) : null}
        {!hasFlow && (totalSteps || subtitle) ? (
          <div className="process-bar-sub-step">
            {totalSteps ? (
              <div className="process-bar-subtitle">{`Step ${stepSeq} out of ${totalSteps}`}</div>
            ) : null}
            {subtitle ? <div className="process-bar-subtitle">{subtitle}</div> : null}
          </div>
        ) : null}
      </div>
    );

    return (
      <div className={hasFlow ? 'process-bar process-bar--has-flow' : 'process-bar'} style={{ color }}>
        {hasFlow ? (
          <div className="process-bar__sticky process-bar__sticky--has-flow">
            <div className="process-bar__flow">
              <FlowNav
                placement="top"
                prev={prev}
                next={next}
                prevText={prevText}
                nextText={nextText}
                disableNext={disableNext}
                center={<PlanSectionTrail />}
              />
            </div>
            {metaRow}
          </div>
        ) : null}
        {!hasFlow && head }
      </div>
    );
  }
}

export default withRouter(ProcessBar);
